
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcFormFooterContainer as ObcFormFooterContainerElement} from '@oicl/openbridge-webcomponents/dist/components/form-footer-container/form-footer-container.js';
 import {ObcFormFooterActionClickEvent} from '@oicl/openbridge-webcomponents/dist/components/form-footer-container/form-footer-container.js';
 export type {ObcFormFooterActionClickEvent} from '@oicl/openbridge-webcomponents/dist/components/form-footer-container/form-footer-container.js';
 

 
 export const ObcFormFooterContainer = createComponent({
   react: React,
   tagName: 'obc-form-footer-container',
   elementClass: ObcFormFooterContainerElement,
   events: {
     
     onActionClick: 'action-click' as EventName<ObcFormFooterActionClickEvent>,
   }
  });
 
 